import Vue from 'vue'
import Global from "@/scripts/Global";
import PostApi from "@/scripts/api/post.api";
import Chat from '@/components/Chat/Chat.vue';
import SessionManager from '@/Manager/Session.manager';
import {
    i18n
} from '@/main'
import VueSignals from '@/scripts/VueSignals';

let posts_number = 20
let posts_to_skip = 0
let messageScroll = true

export default {
    name: 'Search',
    data() {
        return {
            currData: {
                'channel_name': '',
                'channel_id': '',
            },
            searchKeyword: '',
            spinner: false,
            nomore: true,
            debouncer: null,
            debounceInterval: 400
        }
    },
    watch: {
        searchKeyword() {
            this.requestSearch();
        }
    },
    computed: {
        searchPlaceHolder() {
            return `${this.$t('Search')} #${this.currData.channel_name}`;
        }
    },
    mounted() {
        this.currData = this.$parent.data;
    },
    methods: {
        requestSearch() {
            if (!this.debouncer) {
                this.debouncer = this.$_.debounce(() => {
                    this.search();
                }, this.debounceInterval);
            }
            this.debouncer();
        },
        search() {
            this.spinner = true
            // document.execCommand('defaultParagraphSeparator', false, '')
            document.getElementById("search-result").classList = 'search-result';
            document.getElementById("search-result").innerHTML = "";
            let active_channel_doc = SessionManager.getActiveChannel()
            PostApi.Search(active_channel_doc.channel_id, this.searchKeyword, 40).then(res => {
                this.spinner = false;
                if (res.data.result) {
                    if (res.data.posts.length == 0) {
                        document.querySelector(".search-overlay").classList = 'modal-container search-overlay'
                        document.getElementById("search-result").innerHTML = `${this.$t("No message in")} <span class='link'>${this.currData.channel_name}</span> ${this.$t("Contains")} <span class='note'>"'${this.searchKeyword}'"</span>`;
                    } else if (res.data.result && res.data.posts.length > 0) {
                        const ChatViewClass = Vue.extend(Chat)
                        const vm = new ChatViewClass({
                            i18n,
                            propsData: {
                                search_result: res.data.posts,
                            }
                        }).$mount();
                        document.getElementById("search-result").appendChild(vm.$el);
                        document.querySelector(".search-overlay").classList += ' plus';
                        document.getElementById("search-result").addEventListener('scroll', this.handleScroll);
                    } else {
                        document.querySelector(".search-overlay").classList = 'modal-container search-overlay'
                        if (!res.data.reason == "keyword_empty") {
                            document.getElementById("search-result").innerHTML = this.$t("There was an error");
                        }
                        document.getElementById("search-result").classList += " theme-red"
                    }
                }
            }, (error) => {
                this.spinner = false;
            })
        },
        handleScroll(event) {
            var container = event.target
            let maxScroll = container.scrollHeight - container.clientHeight;
            if (container.scrollTop == maxScroll && messageScroll && !this.spinner) {
                messageScroll = false
                this.spinner = true
                posts_to_skip = posts_number
                // let search_text = document.getElementById("search-area").innerText.replace('\\n', '').trim()
                PostApi.Search(SessionManager.getActiveChannel().channel_id, this.searchKeyword, 20, posts_to_skip).then(res => {
                    if (typeof res.data.posts != 'undefined' && res.data.posts.length > 0) {
                        posts_number += res.data.posts.length
                        res.data.posts.forEach(function(currPost) {
                            SessionManager.getActiveSearch().addPost(currPost)
                        })
                        this.spinner = false
                        //works return scroll back to where stopped
                        setTimeout(function(oldScrollHeight, oldScrollTop) {
                            let container = document.querySelector("#chat_queue")
                            container.scrollTop = container.scrollHeight - oldScrollHeight + oldScrollTop
                        }, 10, container.scrollHeight, container.scrollTop);

                        // Can call more
                        messageScroll = true
                    } else {
                        this.nomore = true;
                        messageScroll = false;
                    }
                })
            }
        },
    }
}
